import { config } from "../../../config/config";
import { getNodeAuthHeaders } from "./createAffiliateApi";

export type EditAffiliateInput = {
  affiliateId: string;
  firstName: string;
  lastName: string;
  aType: string;
  isActive: boolean;
  organization?: string | null;
  phoneNumber?: string | null;
  vanderbiltNILFund?: boolean;
  referralLink?: string | null;
  referralCode?: string | null;
};

const getNodeApiBaseUrl = () =>
  (
    process.env.REACT_APP_NODE_API_URL ||
    config.node_api_url ||
    (window.location.hostname === "localhost" ? "http://localhost:4000" : "")
  ).replace(/\/+$/, "");

/** Saves org, phone, nonprofit, type via Node (admin Hasura secret). */
export const editAffiliateViaNodeApi = async (input: EditAffiliateInput) => {
  const nodeApiBaseUrl = getNodeApiBaseUrl();
  if (!nodeApiBaseUrl) {
    throw new Error("REACT_APP_NODE_API_URL is not configured");
  }

  const response = await fetch(`${nodeApiBaseUrl}/api/editAffiliate`, {
    method: "POST",
    headers: getNodeAuthHeaders(),
    body: JSON.stringify({ input: { input } }),
  });

  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(responseData?.message || `Request failed with status ${response.status}`);
  }

  return responseData as { message?: string };
};
